/**
 * Who sees the talent dashboard (the Talent review section of Dashboards).
 *
 * MIRRORS the server guard exactly (performance-service talent_reporting.py):
 * admin and hr_admin by role (`_is_platform_admin`), and anyone else only with the
 * `talent:dashboard` grant, which an administrator narrows to a function or to a
 * department within one (Victor, 9 Oct 2026). HRBPs are NOT included by role.
 * Widening this only produces a section that 403s.
 *
 * What a grant holder does not get is the server's call too: the downloads, and
 * anyone's gender or race. The page reads that from the `viewer` the server sends.
 */
import { hasPermission, hasRole } from '@/auth/permissions'

export const TALENT_DASHBOARD_ROLES = ['admin', 'hr_admin'] as const

/** Deliberately not prefixed 'export:', which would open /admin's Data Export tab. */
export const TALENT_DASHBOARD_KEY = 'talent:dashboard'

type MaybeUser = Parameters<typeof hasRole>[0]

export function canSeeTalentDashboard(user: MaybeUser): boolean {
  return hasRole(user, TALENT_DASHBOARD_ROLES) || hasPermission(user, TALENT_DASHBOARD_KEY)
}
